import type { SelectionCardProps } from '@graftcode/design-system'

import { PACKAGE_MANAGER_ICON } from '@/core/const/packageManagerIcon.const'
import { useNavigationStore } from '@/core/stores/navigationStore'
import type { NavigationData } from '@/core/types/cardNavigation.type'
import type { LibraryData } from '@/core/types/library.type'
import { buildBreadcrumbs } from '@/core/utils/buildBreadcrumbs'
import { formatLibraryLabel } from '@/core/utils/libraries/formatLibraryLabel'

export const getRootNavigation = (
  libraries: Record<string, LibraryData>,
  gateway: string,
  projectName?: string
): NavigationData => {
  const librariesCount = Object.values(libraries).length

  return {
    list: Object.values(libraries).map((lib): SelectionCardProps & { id: string } => ({
      id: lib.id,
      header: formatLibraryLabel(lib),
      children: '',
      showArrow: true,
      icon: PACKAGE_MANAGER_ICON,
      onClick: () => useNavigationStore.getState().navigateTo([lib.id]),
    })),
    details: [],
    breadcrumbs: buildBreadcrumbs(gateway, undefined, undefined, undefined, librariesCount, projectName),
    libraryData: undefined,
    classData: undefined,
  }
}
